<template>
  <div v-if="state.available || error" class="personal-report mt-3">
    <v-sheet v-if="state.available" rounded outlined class="pa-4 report-summary">
      <div class="d-flex align-start">
        <v-avatar color="primary" size="40" class="me-3"><v-icon dark>mdi-file-document-outline</v-icon></v-avatar>
        <div class="flex-grow-1">
          <div class="font-weight-bold">{{ pending ? 'تقريرك بيتجهّز' : state.status === 'ready' ? 'تقريرك جاهز' : state.status === 'failed' ? 'التقرير محتاج محاولة تانية' : 'خطوتك الجاية بعد النتيجة' }}</div>
          <div class="body-2 mt-1">{{ pending ? 'بنراجع نتيجة امتحانك ونرتّب لك أهم التكات وخطوات المراجعة. تقدر ترجع له من تقاريري.' : state.status === 'ready' ? 'تقرير محفوظ من نتيجتك وقت إعداده. افتحه في أي وقت من غير ما تطلبه تاني.' : 'ملخص قصير بأسلوب المستر: اللي عملته صح، وإيه تراجع، وتبدأ منين.' }}</div>
        </div>
      </div>
      <v-progress-linear v-if="pending" indeterminate color="primary" rounded class="mt-4" aria-label="جاري إعداد التقرير" />
      <div class="d-flex flex-wrap align-center mt-3">
        <v-btn v-if="!pending" color="primary" depressed class="px-5 font-weight-bold me-2 mb-2" :loading="busy" @click="requestOrOpen">
          {{ state.status === 'ready' ? 'افتح تقريرك' : state.status === 'failed' ? 'حاول مرة تانية' : state.label }}
        </v-btn>
        <v-btn v-if="!history" text small color="primary" :to="{name:'my-reports'}" class="mb-2">تقاريري السابقة<v-icon small right>mdi-chevron-left</v-icon></v-btn>
      </div>
      <div class="caption grey--text text--darken-1">تقرير مولّد بالذكاء الاصطناعي، لا يغيّر درجاتك.</div>
      <v-alert v-if="error" dense text type="warning" class="mt-3 mb-0" role="alert">{{ error }} <v-btn text small @click="retryStatus">تحديث الحالة</v-btn></v-alert>
    </v-sheet>
    <v-alert v-if="error && !state.available" text dense type="warning">{{error}} <v-btn text small @click="retryStatus">تحديث الحالة</v-btn></v-alert>
    <v-dialog v-model="open" fullscreen transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar flat dense><v-btn icon aria-label="إغلاق التقرير" @click="open = false"><v-icon>mdi-close</v-icon></v-btn><v-toolbar-title>تقريرك الشخصي</v-toolbar-title><v-spacer/><v-btn text @click="printReport"><v-icon left>mdi-printer</v-icon>طباعة</v-btn></v-toolbar>
        <iframe v-if="html && open" ref="reportFrame" title="التقرير الشخصي بالذكاء الاصطناعي" :srcdoc="html" sandbox="allow-same-origin allow-modals" class="report-frame" @load="bindReviewLinks" />
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {createVisiblePoller} from '@/helpers/visible-poller'
export default {
  props: {sessionToken: {type: String, required: true}, initialState: {type:Object, default:null}, history: Boolean},
  data: () => ({state: {available: false}, busy: false, error: '', open: false, html: '', poller: null, disposed: false, requestVersion: 0}),
  computed: {pending() {return ['pending', 'running'].includes(this.state.status)}},
  watch: {
    sessionToken() {this.requestVersion++; this.html = ''; this.open = false; this.state = {available: false}; if(this.poller) this.poller.stop(); this.poller = createVisiblePoller(this.refresh); this.retryStatus()},
    initialState(value) {if(value) this.state = value},
    open(value) {if (!value) this.html = ''},
  },
  mounted() {this.poller = createVisiblePoller(this.refresh); if(this.initialState) this.state = this.initialState; else this.poller.start()},
  beforeDestroy() {this.disposed = true; this.requestVersion++; this.poller.stop()},
  methods: {
    params() {return {session_token: this.sessionToken}},
    retryStatus() {if (this.poller) this.poller.start()},
    async refresh() {
      const version = this.requestVersion;
      try {
        const response = await window.axios.get('/exams/session/report', {params: this.params()});
        if (this.disposed || version !== this.requestVersion) return false;
        this.state = response.data; if (!this.state.available) {this.open = false; this.html = ''} this.error = '';
        return this.pending;
      } catch (e) {if(this.disposed || version !== this.requestVersion) return false; if(e.response && [401,403,404].includes(e.response.status)){this.state={available:false};this.error='';return false} this.error = 'الاتصال اتقطع. هنحاول نحدّث الحالة تلقائيًا.'; return true}
    },
    async requestOrOpen() {
      if (this.busy || this.pending) return; this.busy = true; this.error = ''; const version = this.requestVersion;
      try {
        if (this.state.status === 'ready') {
          const response = await window.axios.get('/exams/session/report/content', {params: this.params(), responseType: 'text'});
          if (!this.disposed && version === this.requestVersion) {this.html = response.data; this.open = true}
        } else {
          const response = await window.axios.post('/exams/session/report', this.params());
          if (!this.disposed && version === this.requestVersion) {this.state = response.data; this.$emit('change'); if(!this.history) this.retryStatus()}
        }
      } catch (e) {if(this.disposed || version !== this.requestVersion) return; await this.refresh(); this.error = e.response && e.response.status === 429 ? 'انتظر دقيقة قبل المحاولة مرة أخرى.' : 'تعذّر فتح التقرير أو طلبه. حدّث النتيجة وحاول مرة أخرى.'}
      finally {this.busy = false}
    },
    bindReviewLinks() {
      const frame = this.$refs.reportFrame;
      if (!frame || !frame.contentDocument) return;
      frame.contentDocument.addEventListener('click', event => {
        const link = event.target.closest('a[href^="#review-question-"]'); if (!link) return;
        event.preventDefault(); const match = link.getAttribute('href').match(/^#review-question-(\d+)$/);
        if (match) {this.open = false; this.$emit('review', Number(match[1]))}
      });
    },
    printReport() {const frame = this.$refs.reportFrame; if (frame && frame.contentWindow) {frame.contentWindow.focus(); frame.contentWindow.print()}},
  },
}
</script>
<style scoped>
.personal-report{width:100%}.report-frame{display:block;border:0;width:100%;height:calc(100vh - 48px);background:#e9efe9}.personal-report .v-btn{max-width:100%;height:auto;min-height:40px;white-space:normal}
</style>
